<h2>Buttons</h2>

<table>
  <tr>
    <td>
      Primary:<br />
      <ul>
        <li>The main action buttons on a page (like "Save" and "Cancel")</li>
        <li>
          The main action buttons in a page section when the page itself has no
          buttons
        </li>
      </ul>

      <p>
        Notice the spacing between them &mdash; the result of
        button_right-spacing being applied:
      </p>

      <p>
        <input
          type="button"
          value="Save"
          class="button_primary button_var_1 button_right-spacing"
        />
        <input
          type="button"
          value="Cancel"
          class="button_primary button_var_1"
        />
      </p>
    </td>
    <td>
      <textarea codeSnippet>
                <input type="button" value="Save" class="button_primary button_var_1 button_right-spacing" />
                
                <input type="button" value="Cancel" class="button_primary button_var_1" />
            </textarea
      >
    </td>
  </tr>

  <tr>
    <td>
      Secondary:<br />
      <ul>
        <li>
          Buttons in a section when the page itself has its own primary buttons
        </li>
        <li>Buttons on rows in a table</li>
        <li>Buttons used for navigation</li>
      </ul>

      <input
        type="button"
        value="Save"
        class="button_secondary button_var_1 button_right-spacing"
      />
      <input
        type="button"
        value="Cancel"
        class="button_secondary button_var_1"
      />
    </td>
    <td>
      <textarea codeSnippet>
                <input type="button" value="Save" class="button_secondary button_var_1 button_right-spacing" />
                
                <input type="button" value="Cancel" class="button_secondary button_var_1" />
            </textarea
      >
    </td>
  </tr>

  <tr>
    <td>
      <div>Icons (with and without text):</div>

      <p>
        <button class="iconButton">
          <i class="fa-regular fa-file-pdf"></i>
        </button>
      </p>

      <p>
        <button class="iconButton">
          <i class="fa-regular fa-file-pdf"></i> Download
        </button>
      </p>
    </td>
    <td>
      <textarea codeSnippet>
                <button class="iconButton"><i class="fa-regular fa-file-pdf" ></i></button>

                <button class="iconButton"><i class="fa-regular fa-file-pdf" ></i> Download</button>
            </textarea
      >
    </td>
  </tr>
</table>
